import { get } from 'lodash';
import * as Yup from 'yup';

export const columns = [
  { field: 'id', headerName: 'ID', width: 90 },
  { field: 'first_name', headerName: 'First Name', width: 200 },
  { field: 'last_name', headerName: 'Last Name', width: 200 },
  { field: 'email', headerName: 'Email', width: 200 },
  { field: 'phone', headerName: 'Phone Number', width: 200 },
  { field: 'address', headerName: 'Address', width: 200 },
  { field: 'city', headerName: 'City', width: 200 },
  { field: 'state', headerName: 'Province/State', width: 200 },
  { field: 'postal_code', headerName: 'Postal/ZIP Code', width: 200 },
  { field: 'country', headerName: 'Country', width: 200 },
];

export const suggestionPrimaryKey = 'first_name';
export const suggestionSecondaryKeys = [
  'email',
  'phone',
  'address',
  'city',
  'state',
  'postal_code',
  'country',
];

export const initialValues = (admin, hasPassword) => {
  const {
    phone,
    address,
    city,
    state,
    postal_code: postalCode,
    country,
    rate,
  } = admin || {};

  const baseValues = {
    firstName: get(admin, 'first_name', ''),
    lastName: get(admin, 'last_name', ''),
    email: get(admin, 'email', ''),
    phone: phone || '',
    address: address || '',
    city: city || '',
    state: state || '',
    postalCode: postalCode || '',
    country: country || '',
    rate: rate || '',
  };

  let passwordValues = {};

  if (hasPassword) {
    passwordValues = {
      password: get(admin, 'password', ''),
      passwordConfirmation: get(admin, 'passwordConfirmation', ''),
    };
  }

  return { ...baseValues, ...passwordValues };
};

export const validationSchema = (hasPassword) => {
  const baseFields = {
    firstName: Yup.string().required('field is required'),
    lastName: Yup.string().required('field is required'),
    email: Yup.string().required('field is required'),
    phone: Yup.string(),
    address: Yup.string(),
    city: Yup.string(),
    state: Yup.string(),
    postalCode: Yup.string(),
    country: Yup.string(),
    rate: Yup.number(),
  };

  let passwordFields = {};

  if (hasPassword) {
    passwordFields = {
      password: Yup.string()
        .required('password is required')
        .min(8, 'Your password is too short.')
        .max(50, 'Your password is too long.'),
      passwordConfirmation: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .min(8, 'Your password is too short.')
        .max(50, 'Your password is too long.')
        .required('password is required'),
    };
  }

  return Yup.object().shape({
    ...baseFields,
    ...passwordFields,
  });
};
